import { useId } from 'react'
import type { ReactElement } from 'react'
import { PhonePromptCard } from './PhonePromptCard'
import { PromptBenefitList } from './PromptBenefitList'
import { PROMPT_COPY } from './promptCopy'
import styles from './phonePromptText.module.css'

/** Phone, no route (home, station, line) — Figma 9351:77621 / 9352:17549. */
export function PhoneHomePrompt({
  storeHref,
  onGetTheApp,
  onBack,
}: {
  readonly storeHref: string
  readonly onGetTheApp: () => void
  readonly onBack: () => void
}): ReactElement {
  const titleId = useId()
  return (
    <PhonePromptCard
      labelledBy={titleId}
      placement="center"
      icon="large"
      contentTop={70}
      primary={{ label: PROMPT_COPY.getTheApp }}
      primaryHref={storeHref}
      secondary={{ label: PROMPT_COPY.backToWeb }}
      order="secondaryFirst"
      onPrimary={onGetTheApp}
      onSecondary={onBack}
    >
      <h2 id={titleId} className={styles.homeTitle}>
        {PROMPT_COPY.home.title}
      </h2>
      <PromptBenefitList benefits={PROMPT_COPY.home.benefits} layout="stacked" />
    </PhonePromptCard>
  )
}
